import { Icon, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Skeleton } from 'native-base';
import React from 'react';

import { ManagementFeeStatus } from '../../../../../store/rateManagement/constants';

import { MasterAccountField } from './MasterAccountField';

import { CardTypes } from '.';

export const CardTablet: React.FC<CardTypes.Props> = ({ loading, sentOrderDetail }) => {
  const skeletons = (
    <VStack alignItems="center" w="100%" space={Spacing['stack.quarck']}>
      <HStack justifyContent="space-between" width="100%" space={Spacing['stack.quarck']}>
        {Array.from({ length: 4 }, (_, index) => (
          <Skeleton
            pr={Spacing['inline.nano']}
            key={index}
            width="18%"
            testID={`test-skeleton-${index}`}
            borderRadius="sm"
            height="14px"
          />
        ))}
      </HStack>
      <HStack justifyContent="space-between" width="100%" space={Spacing['stack.quarck']}>
        {Array.from({ length: 4 }, (_, index) => (
          <Skeleton
            pr={Spacing['inline.nano']}
            key={index}
            width="18%"
            testID={`test-skeleton-${index}`}
            borderRadius="sm"
            height="14px"
          />
        ))}
      </HStack>
    </VStack>
  );

  return (
    <VStack
      maxHeight={154}
      marginBottom={Spacing['stack.xxs']}
      borderRadius="md"
      backgroundColor={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}
      p={Spacing['stack.xxxs']}
      justifyContent="space-between"
      width="100%">
      {loading ? (
        <VStack space={Spacing['stack.xxxs']}>
          {skeletons}
          {skeletons}
        </VStack>
      ) : (
        <HStack justifyContent="space-between">
          <VStack space={Spacing['stack.xxxs']}>
            <VStack space={Spacing['stack.quarck']}>
              <Text
                isLoading={loading}
                fontSize={Typography['fontsize.md']}
                color="neutral.black"
                fontWeight={Typography['fontweight.semibold']}>
                ID solicitação
              </Text>
              <Text fontSize={Typography['fontsize.md']} color="neutral.dark">
                {sentOrderDetail?.managementFeeHashNormalized}
              </Text>
            </VStack>

            <VStack space={Spacing['stack.quarck']}>
              <Text
                isLoading={loading}
                fontSize={Typography['fontsize.md']}
                color="neutral.black"
                fontWeight={Typography['fontweight.semibold']}>
                Mês de competência
              </Text>
              <Text fontSize={Typography['fontsize.md']} color="neutral.dark">
                {sentOrderDetail?.managementFeeMonthNormalized}
              </Text>
            </VStack>
          </VStack>

          <VStack space={Spacing['stack.xxxs']}>
            <VStack space={Spacing['stack.quarck']}>
              <Text
                isLoading={loading}
                fontSize={Typography['fontsize.md']}
                color="neutral.black"
                fontWeight={Typography['fontweight.semibold']}>
                Tipo
              </Text>
              <Text isLoading={loading} fontSize={Typography['fontsize.md']} color="neutral.dark">
                {sentOrderDetail?.managementFeeTypeNormalized}
              </Text>
            </VStack>

            <VStack space={Spacing['stack.quarck']}>
              <Text
                isLoading={loading}
                fontSize={Typography['fontsize.md']}
                color="neutral.black"
                fontWeight={Typography['fontweight.semibold']}>
                Total de clientes
              </Text>
              <HStack alignItems="center" height={4}>
                <Icon name="People" size="xxs" testId="people-icon" color="neutral.dark" />
                <Text
                  isLoading={loading}
                  paddingLeft={Spacing['inline.quarck']}
                  textAlign="center"
                  alignSelf="center"
                  fontSize={Typography['fontsize.md']}
                  color="neutral.dark">
                  {sentOrderDetail?.managementFeeStatusNormalized !== ManagementFeeStatus.Sent
                    ? sentOrderDetail?.validCustomerTotal
                    : sentOrderDetail?.customerTotal}
                </Text>
              </HStack>
            </VStack>
          </VStack>

          <VStack space={Spacing['stack.xxxs']}>
            <VStack space={Spacing['stack.quarck']}>
              <Text
                isLoading={loading}
                fontSize={Typography['fontsize.md']}
                color="neutral.black"
                fontWeight={Typography['fontweight.semibold']}>
                Clientes validados
              </Text>
              <HStack alignItems="center" height={4}>
                <Icon
                  name="Check"
                  color={Color['feedback.success.default']}
                  size="xxs"
                  testId="check-icon"
                  variant="rounded"
                  padding={2}
                  backgroundColor={Color['feedback.success.lightest']}
                />
                <Text
                  isLoading={loading}
                  paddingLeft={Spacing['inline.quarck']}
                  fontSize={Typography['fontsize.md']}
                  color="neutral.dark">
                  {sentOrderDetail?.validCustomerTotal}
                </Text>
              </HStack>
            </VStack>

            {(sentOrderDetail?.managementFeeStatusNormalized === ManagementFeeStatus.Processed ||
              sentOrderDetail?.managementFeeStatusNormalized === ManagementFeeStatus.Cancelled) && (
              <VStack space={Spacing['stack.quarck']}>
                <Text
                  isLoading={loading}
                  fontSize={Typography['fontsize.md']}
                  color="neutral.black"
                  fontWeight={Typography['fontweight.semibold']}>
                  Clientes Inválidos
                </Text>
                <HStack alignItems="center" height={4}>
                  <Icon
                    name="Close"
                    color={Color['feedback.error.default']}
                    size="xxs"
                    testId="close-icon"
                    variant="rounded"
                    backgroundColor={Color['feedback.error.lightest']}
                  />
                  <Text
                    isLoading={loading}
                    paddingLeft={Spacing['inline.quarck']}
                    fontSize={Typography['fontsize.md']}
                    color="neutral.dark">
                    {sentOrderDetail?.invalidCustomerTotal}
                  </Text>
                </HStack>
              </VStack>
            )}

            {(sentOrderDetail?.managementFeeStatusNormalized === ManagementFeeStatus.Sent ||
              sentOrderDetail?.managementFeeStatusNormalized === ManagementFeeStatus.Scheduled) && (
              <VStack space={Spacing['stack.quarck']}>
                <Text
                  fontSize={Typography['fontsize.md']}
                  color="neutral.black"
                  fontWeight={Typography['fontweight.semibold']}>
                  Hora/data de Envio
                </Text>
                <Text fontSize={Typography['fontsize.md']} color="neutral.dark">
                  {sentOrderDetail?.managementFeeSentAtNormalized}
                </Text>
              </VStack>
            )}
          </VStack>

          <VStack space={Spacing['stack.xxxs']}>
            <VStack space={Spacing['stack.quarck']}>
              <Text
                fontSize={Typography['fontsize.md']}
                color="neutral.black"
                fontWeight={Typography['fontweight.semibold']}>
                Total a receber
              </Text>
              <Text fontSize={Typography['fontsize.md']} color="neutral.dark">
                {sentOrderDetail?.totalAmountToReceiveNormalized}
              </Text>
            </VStack>

            <MasterAccountField loading={loading} sentOrderDetail={sentOrderDetail} />

            {/* {sentOrderDetail?.managementFeeStatusNormalized === ManagementFeeStatus.Processed &&
              sentOrderDetail.managerInfo.isConsulting && (
                <VStack space={Spacing['stack.quarck']}>
                  <Box marginBottom={5} width="60%">
                    <Input
                      onBlur={() => {
                        if (inputValue && inputValue.length >= 5) {
                          setError({});
                        } else {
                          setError({ type: 'error', message: 'Campo obrigatório' });
                        }
                      }}
                      inputRightElement={
                        inputValue?.length === 0 ? (
                          <Box pr={Spacing['inline.nano']}>
                            <Icon
                              testId="qa"
                              name="EditPen"
                              size="xs"
                              color={Color['brand.tertiary.principal']}
                            />
                          </Box>
                        ) : (
                          <Pressable onPress={handleClearInput}>
                            <Box pr={Spacing['inline.nano']}>
                              <IconStatus
                                icon="Close"
                                color={Color['brand.primary.principal']}
                                size="xxxs"
                                testId="close-icon"
                                bgColor={Color['neutral.light']}
                              />
                            </Box>
                          </Pressable>
                        )
                      }
                      {...(error.message && { error })}
                      color={
                        error.message ? Color['feedback.error.default'] : Color['neutral.darkest']
                      }
                      testId="account-input"
                      rules={{
                        maxLength: 7,
                        max: 7,
                        min: 5,
                        required: true,
                        minLength: 5,
                        valueAsNumber: true,
                      }}
                      placeholder="00000"
                      variant="filled"
                      autoComplete="off"
                      name=""
                      value={inputValue}
                      onChange={handleInputChange}
                    />
                  </Box>
                </VStack>
              )} */}
          </VStack>
        </HStack>
      )}
    </VStack>
  );
};
